import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import AppRouter from './router';
import * as serviceWorker from './serviceWorker';
import './index.scss';

var history = createBrowserHistory();

ReactDOM.render(
    <AppRouter history={history} />,
    document.getElementById('main'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
